<template>
  <div class="bg-white p-10">
    <div class="mb-5">ADD DEPARTMENTS</div>
    <div>
      <v-text-field
        placeholder="Department Name"
        v-model="department"
        outlined
        color
      ></v-text-field>
    </div>
    <div>
      <div class="mt-5">
        <v-btn
          @click="$emit('cancelAdd')"
          small
          elevation=""
          color=""
          class="mr-2"
          >CANCEL</v-btn
        >
        <v-btn small @click="addDepartment">SUBMIT</v-btn>
      </div>
      <v-snackbar top v-model="snackbar">
        {{ snackbarText }}
        <v-btn text color="primary" @click.native="snackbar = false"
          >Close</v-btn
        >
      </v-snackbar>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import EventBus from "@/EventBus";

export default {
  data() {
    return {
      snackbar: false,
      snackbarText: "",
      department: "",
      departments: [],
    };
  },
  methods: {
    addDepartment() {
      let data = {
        department: this.department,
      };
      axios.post("/departments/add", data).then((res) => {
        if (res.data.status) {
          EventBus.$emit("refreshDepartment");
        } else {
          this.snackbar = true;
          this.snackbarText = res.data.message;
        }
      });
    },
  },
};
</script>
